import { render, staticRenderFns } from "./XMLImport.vue?vue&type=template&id=4f0b5a38&scoped=true&"
import script from "./XMLImport.vue?vue&type=script&lang=js&"
export * from "./XMLImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b5a38",
  null
  
)

export default component.exports